// extracted by mini-css-extract-plugin
module.exports = {"container":"NavigationArrows_container__kfyU4","text":"NavigationArrows_text__3RLXA","disabled":"NavigationArrows_disabled__V3oNc"};